import { render } from "./TicketDetails.vue?vue&type=template&id=3ecc387a&scoped=true"
import script from "./TicketDetails.vue?vue&type=script&lang=js"
export * from "./TicketDetails.vue?vue&type=script&lang=js"

import "./TicketDetails.vue?vue&type=style&index=0&id=3ecc387a&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ecc387a"]])

export default __exports__